import React, { useEffect, useState } from 'react';

/**
 * Secção retrátil com título e chevron (padrão Ludi).
 */
export default function CollapsibleSection({
  title,
  defaultOpen = true,
  open: openProp,
  onOpenChange,
  className = '',
  children,
}) {
  const isControlled = openProp !== undefined;
  const [internalOpen, setInternalOpen] = useState(defaultOpen);
  const open = isControlled ? openProp : internalOpen;

  useEffect(() => {
    if (!isControlled) setInternalOpen(defaultOpen);
  }, [defaultOpen, isControlled]);

  const toggle = () => {
    const next = !open;
    if (isControlled) onOpenChange?.(next);
    else setInternalOpen(next);
  };

  return (
    <div className={className}>
      <button
        type="button"
        onClick={toggle}
        className="flex w-full items-center justify-between font-mono text-[10px] uppercase tracking-wider text-iron-muted"
      >
        <span>{title}</span>
        <span className="text-iron-accent">{open ? '▼' : '▶'}</span>
      </button>
      {open ? <div className="mt-3">{children}</div> : null}
    </div>
  );
}
